<template>
  <div>
    <div class="heaer-text">LT预测表</div>
    <div class="table-wrap">
      <lt-filter
        @showLoading="showLoading"
        @downloadFile="downloadFile"
        @refreshTable="refreshTable"
      ></lt-filter>
      <lt-table
        ref="lttable"
        :column="column"
        :fathercolumn="fathercolumn"
        :loading="loading"
      ></lt-table>
    </div>
  </div>
</template>
<script>
import { fathercolumn } from "./data";
import LtTable from "./ltTable.vue";
import LtFilter from "./ltFilter.vue";

export default {
  components: {
    LtFilter,
    LtTable,
  },
  data() {
    return {
      loading: false,
      fathercolumn: fathercolumn,
    };
  },
  methods: {
    showLoading(value) {
      this.loading = value;
    },
    downloadFile() {
      this.$refs.lttable.downLoadFileToExcel();
    },
    refreshTable() {
      this.$refs.lttable.$refs.table.doLayout();
      this.$nextTick(() => {
        this.$refs.lttable.$refs.table.doLayout();
      });
    },
  },
  computed: {
    column() {
      let column;
      let arr = JSON.parse(JSON.stringify(this.fathercolumn));
      switch (this.$store.state.Summary.PredictDimension) {
        case "1":
          arr[0] = {
            id: 1,
            key: "维度",
            name: "维度",
            fixed: true,
            width: 150,
            children: [
              {
                id: 0,
                key: "installDay",
                name: "全部(日期)",
                // sort: true,
                point: 0,
                width: 150,
                fixed: true,
                show: true,
                fatherid: 1,
              },
            ],
          };
          column = arr;
          break;
        case "2":
          arr[0] = {
            id: 1,
            key: "维度",
            name: "维度",
            fixed: true,
            width: 150,
            children: [
              {
                id: 0,
                key: "geo",
                name: "地区",
                // sort: true,
                point: 0,
                width: 150,
                fixed: true,
                show: true,
                fatherid: 1,
              },
            ],
          };
          column = arr;
          break;
        case "3":
          arr[0] = {
            id: 1,
            key: "维度",
            name: "维度",
            fixed: true,
            width: 150,
            children: [
              {
                id: 0,
                key: "mediaSource",
                name: "渠道",
                // sort: true,
                point: 0,
                width: 150,
                fixed: true,
                show: true,
                fatherid: 1,
              },
            ],
          };
          column = arr;
          break;
        case "4":
          arr[0] = {
            id: 1,
            key: "维度",
            name: "维度",
            fixed: true,
            width: 400,
            children: [
              {
                id: -1,
                key: "mediaSource",
                name: "渠道",
                // sort: true,
                point: 0,
                width: 200,
                fixed: true,
                show: true,
                fatherid: 1,
              },
              {
                id: 0,
                key: "campaign",
                name: "campaign",
                // sort: true,
                point: 0,
                width: 200,
                fixed: true,
                show: true,
                fatherid: 1,
              },
            ],
          };
          arr[1].width = 400;
          column = arr;
          break;
        default:
          arr[0].width = 150;
          column = arr;
      }
      return column;
    },
  },
};
</script>
<style scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 15px;
}
</style>
